<template>
  <!-- Page Introduction Wrapper -->
    <div class="page-style-a">
        <div class="container">
            <div class="page-intro">
                <h2>Shop</h2>
                <ul class="bread-crumb">
                    <li class="has-separator">
                        <i class="ion ion-md-home"></i>
                        <router-link :to="{name : 'Home'}">Home</router-link>
                    </li>
                    <li class="is-marked">
                        <a href="shop-v2-sub-category.html">Shop</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <!-- Page Introduction Wrapper /- -->
</template>

<script>
export default {

}
</script>

<style>

</style>